module.exports = __webpack_public_path__ + "static/media/jcb.6ddc5783.svg";